import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import Iconify from '../../../../components/Iconify';

export const OwnershipDialog = ({ open, setOpen, takeControlCallback }) => (
  <Dialog open={open} onClose={() => {}}>
    <DialogTitle>
      <Stack direction="row" alignItems="center" spacing={2} mb={2}>
        <Iconify icon="eva:info-fill" color="#007BFF" /> <Typography color="primary">Diagram jest obecnie edytowany przez inną osobę</Typography>
      </Stack>
    </DialogTitle>
    <DialogContent>
      <Typography color="primary">
          Czy chcesz przejąć nad nim kontrolę?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => takeControlCallback(false)} variant="contained" color="primary">
          Nie
      </Button>
      <Button onClick={() => takeControlCallback(true)} variant="contained" color="primary">
          Tak
      </Button>
    </DialogActions>
  </Dialog>
);
